import { toast } from "sonner";
import { fireMochiNotification } from "@/lib/mochiNotifications";

// ADHD shame-safe celebratory lines, keyed by the win type returned from the
// backend toggle endpoints. Copy comes directly from the personality spec.
export const WIN_LINES = {
    first_task:  { line: "You started. That's everything.", icon: "🌱" },
    three_tasks: { line: "Okay that's actually impressive.", icon: "✨" },
    pomodoro:    { line: "Full focus. I felt that.",         icon: "🔥" },
    habit:       { line: "You showed up for yourself today.", icon: "💛" },
    stale_task:  { line: "That one took courage. Nice.",     icon: "🍃" },
    return:      { line: "You came back. That's the whole game.", icon: "🍡" },
};

// Track recent win toast keys so we never stack >2 win notifications at once
let queue = [];
const MAX_STACK = 2;
const DEFAULT_DUR = 3000;

export function celebrateWin(key) {
    const entry = WIN_LINES[key];
    if (!entry) return;
    // Trim to MAX_STACK active toasts
    queue = queue.filter((t) => Date.now() - t.at < DEFAULT_DUR);
    if (queue.length >= MAX_STACK) return;
    const id = toast(entry.line, {
        icon: entry.icon,
        duration: DEFAULT_DUR,
        style: { fontWeight: 600 },
    });
    queue.push({ id, at: Date.now() });

    // Mirror the win to an OS-level notification when the tab is in the
    // background — that's when the user actually benefits from a push.
    // Uses Mochi's voice via the dispatcher; title is "mochi 🍡".
    if (typeof document !== "undefined" && document.visibilityState === "hidden") {
        fireMochiNotification("win_celebration", {}, { tag: `win-${key}` });
    }
}
